'use es6';

const LEGACY_UUID_IDENTIFIER = '-';
const getLegacyUuidIdentifier = () => LEGACY_UUID_IDENTIFIER;
export default getLegacyUuidIdentifier;